<script lang="ts">export let value = false;
export let labels = ['Aanwezig', 'Afwezig'];
export let action = undefined;
export let csrf;
</script>

{#snippet badge(value = false, labels = [])}
    <span class="badge badge-soft {value ? 'badge-success' : 'badge-error'} text-xs">
      {value ? labels[0] : labels[1]}
    </span>
{/snippet}

{#if action && csrf}
    <form method="post" action="{action}">
        <input type="hidden" name="_token" value="{csrf}">
        <button>
            {@render badge(value, labels)}
        </button>
    </form>
{:else}
    {@render badge(value, labels)}
{/if}
